import { Field, Int, ObjectType } from 'type-graphql'

import { ScalarObject } from '@things-factory/shell'

@ObjectType({
  description: 'Represents a specification item that defines the structure and validation rules for a data field.'
})
export class DataSpecItem {
  @Field({ description: 'The data type of the specification item.' })
  type: string

  @Field({ description: 'The display label for the specification item.' })
  label: string

  @Field({ description: 'The unique name identifier for the specification item.' })
  name: string

  @Field({ nullable: true, description: 'Placeholder text for the input field.' })
  placeholder?: string

  @Field(type => ScalarObject, {
    nullable: true,
    description: 'Additional properties and configuration for the specification item.'
  })
  property?: { [key: string]: any }
}

@ObjectType({
  description:
    'Represents a data specification that defines the structure, validation rules, and metadata for a dataset.'
})
export class DataSpec {
  @Field({ description: 'The unique name identifier for the data specification.' })
  name: string

  @Field({ nullable: true, description: 'A description of the data specification and its purpose.' })
  description: string

  @Field({ nullable: true, description: 'Help text or documentation for the data specification.' })
  help: string

  @Field(type => [DataSpecItem], {
    nullable: true,
    description: 'The specification items that define the data structure and validation rules.'
  })
  specItems: DataSpecItem[]
}

@ObjectType({ description: 'Represents a paginated list of data specifications.' })
export class DataSpecList {
  @Field(type => [DataSpec], { description: 'List of data specifications.' })
  items: DataSpec[]

  @Field(type => Int, { description: 'Total number of data specifications in the list.' })
  total: number
}
